import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Typography } from '@telus-uds/components-web';

import ComfirmationBox from './ConfirmationBox';
import { ButtonContainer, ModalBodyContainer, customStyles } from './css';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { localeEn } from '../../components/misc';
import { useLocaleContext } from '../../components/context/LocaleContext';

const SessionTimeout = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const locale = useLocaleContext();
  const {
    WLS: {
      SessionTimeout: { alertTitle, bodyMessage, buttonText }
    }
  } = (locale || localeEn) === localeEn ? EN : FR;

  const checkTokenExpiry = () => {
    const tokenExpiry = localStorage.getItem('tokenExpiry');
    if (tokenExpiry && Date.now() > parseInt(tokenExpiry, 10)) {
      // Token has expired
      if (localStorage.getItem('accessToken') !== null) {
        setOpen(true);
      }
    }
  };

  const checkTokenInterceptors = () => {
    if (localStorage.getItem('isExpired') === 'true') {
      if (localStorage.getItem('accessToken') !== null) {
        setOpen(true);
      }
    }
  };

  const handleLogin = () => {
    setOpen(false);
    localStorage.clear();
    window.location.pathname = '/';
  };

  useEffect(() => {
    let sessionInterval;
    if (localStorage.getItem('accessToken') !== null) {
      sessionInterval = setInterval(() => {
        checkTokenExpiry();
        checkTokenInterceptors();
      }, 5000);
    } else {
      clearInterval(sessionInterval);
    }
  }, []);

  return (
    <>
      {children}
      <ComfirmationBox
        hideCloseButton
        open={isOpen}
        setOpen={setOpen}
        customStyles={customStyles}
        header={alertTitle}
      >
        <ModalBodyContainer>
          <Typography block>{bodyMessage}</Typography>
          <ButtonContainer>
            <Button onClick={handleLogin}>{buttonText}</Button>
          </ButtonContainer>
        </ModalBodyContainer>
      </ComfirmationBox>
    </>
  );
};

SessionTimeout.propTypes = {
  children: PropTypes.node.isRequired
};

export default SessionTimeout;
